var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuleWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C11.2091 17 13.2091 16.1046 14.6568 14.6568C16.1046 13.2091 17 11.2091 17 9C17 6.79088 16.1046 4.79088 14.6568 3.34314C13.2091 1.89543 11.2091 1 9 1C6.79088 1 4.79088 1.89543 3.34314 3.34314C1.89543 4.79088 1 6.79088 1 9C1 11.2091 1.89543 13.2091 3.34314 14.6568C4.79088 16.1046 6.79088 17 9 17Z",
    stroke: "#FFCC56",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20006 4.2666V10.1333H9.80006V4.2666H8.20006ZM10.1733 12.6667C10.1733 13.3147 9.648 13.84 8.99999 13.84C8.35199 13.84 7.82666 13.3147 7.82666 12.6667C7.82666 12.0186 8.35199 11.4933 8.99999 11.4933C9.648 11.4933 10.1733 12.0186 10.1733 12.6667Z",
    fill: "#FFCC56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuleWarn);
export default __webpack_public_path__ + "static/media/rule-warn.8d9088b482a563fb17183773bf03ea15.svg";
export { ForwardRef as ReactComponent };